import { render, staticRenderFns } from "./HistorialComponent.vue?vue&type=template&id=5849a45e&"
import script from "./HistorialComponent.vue?vue&type=script&lang=js&"
export * from "./HistorialComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports